import React from 'react';
const languages = [{
  name: 'English',
  color: 'crimson'
}, {
  name: 'العربية',
  color: 'cobalt'
}, {
  name: '日本語',
  color: 'emerald'
}, {
  name: 'Deutsch',
  color: 'saffron'
}, {
  name: 'Português',
  color: 'crimson'
}, {
  name: 'Ελληνικά',
  color: 'cobalt'
}, {
  name: '한국어',
  color: 'emerald'
}, {
  name: 'Español',
  color: 'saffron'
}, {
  name: 'Français',
  color: 'crimson'
}, {
  name: 'Italiano',
  color: 'cobalt'
}, {
  name: 'Svenska',
  color: 'emerald'
}, {
  name: 'Suomi',
  color: 'saffron'
}, {
  name: 'Norsk',
  color: 'crimson'
}, {
  name: 'Türkçe',
  color: 'cobalt'
}, {
  name: 'Polski',
  color: 'emerald'
}, {
  name: 'Čeština',
  color: 'saffron'
}, {
  name: 'Română',
  color: 'crimson'
}, {
  name: 'Magyar',
  color: 'cobalt'
}, {
  name: 'Български',
  color: 'emerald'
}, {
  name: 'Hrvatski',
  color: 'saffron'
}, {
  name: 'Српски',
  color: 'crimson'
}, {
  name: 'Slovenščina',
  color: 'cobalt'
}, {
  name: 'Eesti',
  color: 'emerald'
}, {
  name: 'Latviešu',
  color: 'saffron'
}, {
  name: 'Lietuvių',
  color: 'crimson'
}, {
  name: 'ภาษาไทย',
  color: 'cobalt'
}, {
  name: 'Tiếng Việt',
  color: 'emerald'
}, {
  name: 'Bahasa Indonesia',
  color: 'saffron'
}, {
  name: 'हिन्दी',
  color: 'crimson'
}, {
  name: '中文',
  color: 'cobalt'
}];
const colorMap: Record<string, string> = {
  crimson: 'bg-crimson',
  cobalt: 'bg-cobalt',
  emerald: 'bg-emerald',
  saffron: 'bg-saffron'
};
function LanguageItem({
  name,
  color
}: {
  name: string;
  color: string;
}) {
  return <span className="inline-flex flex-col items-center mx-6 md:mx-10 flex-shrink-0" data-id="element-232">
      <span className="font-heading text-lg md:text-2xl font-bold text-ivory whitespace-nowrap tracking-wide" data-id="element-233">
        {name}
      </span>
      <span className={`${colorMap[color]} h-1 w-full mt-1`} data-id="element-234" />
    </span>;
}
export function Marquee() {
  return <div className="w-full overflow-hidden border-y-2 border-ivory/20 py-4 md:py-6 bg-midnight" data-id="element-235">
      <div className="animate-marquee flex whitespace-nowrap" style={{
      width: 'max-content'
    }} data-id="element-236">
        {languages.map((lang, i) => <LanguageItem key={`a-${i}`} name={lang.name} color={lang.color} data-id="element-237" />)}
        {languages.map((lang, i) => <LanguageItem key={`b-${i}`} name={lang.name} color={lang.color} data-id="element-238" />)}
      </div>
    </div>;
}